// injector
import { Context } from "@nuxt/types/app";
import { defineNuxtPlugin } from "@nuxtjs/composition-api";

import { commonPlugin } from "./common";
import { filePlugin } from "./file";
import { formattingPlugin } from "./formatting";
const moduleTypePlugin = async () => await import("./module-type");
const permissionPlugin = async () => await import("./permission");
const rolePlugin = async () => await import("./role");
import { uiPlugin } from "./ui";
import { unitPlugin } from "./unit";

export default defineNuxtPlugin(
  async (context: Context, inject): Promise<void> => {
    inject("common", commonPlugin(context));
    inject(
      "moduleType",
      await moduleTypePlugin().then((moduletype) =>
        moduletype.moduleTypePlugin(context),
      ),
    );
    inject(
      "permission",
      await permissionPlugin().then((permission) =>
        permission.permissionPlugin(context),
      ),
    );
    inject("role", await rolePlugin().then((role) => role.rolePlugin(context)));
    inject("file", filePlugin(context));
    inject("unit", unitPlugin(context));
    inject("formatting", formattingPlugin(context));
    inject("ui", uiPlugin(context));
  },
);

// dynamic
// https://stackoverflow.com/a/45283062/9433691
// https://stackoverflow.com/questions/44987464/import-all-modules-from-a-directory-at-once-node
